import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../elements/icon';
import Omega3BoxImage from '../../../assets/omega3/1.webp';

const CustomFormulaForm = ({
  name,
  setName,
  email,
  setEmail,
  isGeneric,
  setIsGeneric,
  discount_code,
  setDiscountCode,
  note,
  setNote,
  onSaveFormula,
  isCreateCustomFormulaLoading,
  showGenericOption = true,
  hasOmega3Recommended = false,
  setHasOmega3Recommended,
}) => {
  const { t } = useTranslation();

  return (
    <div className="!t-w-full t-flex t-flex-col t-gap-4 t-items-center t-justify-center mb-4">
      {showGenericOption && (
        <div className="t-flex t-items-center t-self-start t-gap-2">
          <label className="t-flex t-items-center t-gap-2 t-cursor-pointer">
            <input type="checkbox" checked={isGeneric} onChange={(e) => setIsGeneric(e.target.checked)} />
            <span className="t-text-gray-600">{t('CustomFormulaForm_GenericToggleLabel')}</span>
          </label>
          <div className="t-relative t-flex t-items-center t-group">
            <button
              type="button"
              className="t-inline-flex t-items-center t-justify-center t-text-xs t-font-semibold t-text-gray-600"
              aria-label={t('CustomFormulaForm_GenericTooltip')}
            >
              <Icon name="infoFilled" size="18" color="#003b4d" raw />
            </button>
            <div className="t-pointer-events-none t-absolute t-left-1/2 t-top-full t-z-20 t-mt-2 t-w-[260px] -t-translate-x-1/2 t-rounded-md t-bg-black t-px-3 t-py-2 t-text-left t-text-xs t-leading-5 t-text-white t-opacity-0 t-invisible t-transition-opacity group-hover:t-visible group-hover:t-opacity-100 group-focus-within:t-visible group-focus-within:t-opacity-100">
              {t('CustomFormulaForm_GenericTooltip')}
            </div>
          </div>
        </div>
      )}
      <div className="!t-w-full t-flex t-flex-col md:t-flex-row t-gap-4 t-items-start t-justify-start">
        <div className="t-w-full t-flex t-flex-col t-gap-4 ">
          <div className="!t-w-full t-flex t-flex-col t-items-start t-gap-0 position-relative">
            <label className="t-text-gray-600 !t-ml-0">
              {isGeneric
                ? t('CustomFormulaForm_InternalTitleLabel')
                : t('CustomFormulaForm_CustomerNameLabel')}
            </label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder={
                isGeneric
                  ? t('CustomFormulaForm_InternalTitlePlaceholder')
                  : t('CustomFormulaForm_CustomerNamePlaceholder')
              }
              className={`form-control t-h-[40px] !t-pl-3`}
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              minLength={3}
            />
          </div>
          {!isGeneric && (
            <div className="!t-w-full t-flex t-flex-col t-items-start t-gap-0 position-relative">
              <label className="t-text-gray-600 !t-ml-0">{t('CustomFormulaForm_CustomerEmailLabel')}</label>
              <input
                type="text"
                name="email"
                id="email"
                placeholder={t('CustomFormulaForm_CustomerEmailPlaceholder')}
                className={`form-control t-h-[40px] !t-pl-3`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                minLength={3}
              />
            </div>
          )}
          <div className="!t-w-full t-flex t-flex-col t-items-start t-gap-0 position-relative">
            <label className="t-text-gray-600 !t-ml-0">{t('CustomFormulaForm_DiscountCodeLabel')}</label>
            <input
              type="text"
              name="discount_code"
              id="discount_code"
              placeholder={t('CustomFormulaForm_DiscountCodePlaceholder')}
              className={`form-control t-h-[40px] !t-pl-3`}
              value={discount_code}
              onChange={(e) => setDiscountCode(e.target.value)}
              minLength={3}
            />
          </div>
        </div>

        <div className="t-flex t-flex-col t-gap-4 t-w-full">
          <div className="!t-w-full t-flex t-flex-col t-items-start t-gap-0 position-relative">
            <label className="t-text-gray-600 !t-ml-0">{t('CustomFormulaForm_NoteLabel')}</label>
            <textarea
              type="text"
              name="note"
              id="note"
              placeholder={t('CustomFormulaForm_NotePlaceholder')}
              className={`form-control !t-pl-3`}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows={4}
            />
          </div>
        </div>
      </div>
      <div className="t-flex t-items-center t-gap-4">
        <button
          className="btn !t-py-1 md:!t-w-[170px] !t-mx-auto text-lowercase btn-custom-quaternary !t-rounded-md"
          onClick={() => onSaveFormula(true)}
          disabled={isCreateCustomFormulaLoading}
        >
          {t('CustomFormulaForm_Save')}
        </button>
        {!isGeneric && (
          <button
            className="btn !t-py-1 md:!t-w-[200px] !t-mx-auto text-lowercase btn-custom-quaternary !t-rounded-md"
            onClick={() => onSaveFormula(false)}
            disabled={isCreateCustomFormulaLoading}
          >
            {t('CustomFormulaForm_SaveAndSend')}
          </button>
        )}
      </div>
      <label
        className={`t-flex t-w-full t-cursor-pointer t-items-start t-gap-3 t-rounded-lg t-border t-bg-white t-p-3 ${
          hasOmega3Recommended ? 't-border-quaternary t-ring-2 t-ring-quaternary/20' : 't-border-gray-200'
        }`}
      >
        <img
          src={Omega3BoxImage}
          alt={t('CustomFormulaForm_Omega3ImageAlt')}
          className="t-h-20 t-w-20 t-rounded-md t-bg-[#f7fbf9] t-object-contain t-p-1"
        />
        <span className="t-flex t-flex-1 t-items-start t-gap-3">
          <input
            type="checkbox"
            checked={hasOmega3Recommended}
            onChange={(e) => setHasOmega3Recommended?.(e.target.checked)}
            className="t-mt-1 t-h-4 t-w-4 t-rounded t-border-gray-300 t-text-quaternary focus:t-ring-quaternary"
          />
          <span className="t-flex t-flex-col t-gap-1">
            <span className="t-font-sans t-text-sm t-font-bold t-text-secondary">
              {t('CustomFormulaForm_Omega3Title')}
            </span>
            <span className="t-font-sans t-text-sm t-text-gray-700">
              {t('CustomFormulaForm_Omega3Description')}
            </span>
            <span className="t-font-sans t-text-xs t-font-medium t-text-gray-500">
              {t('CustomFormulaForm_Omega3PackagingNote')}
            </span>
          </span>
        </span>
      </label>
    </div>
  );
};

export default CustomFormulaForm;
